import './select-compte-beneficiaires-form.css'
import React, { useState } from 'react'
import { Form, Modal } from 'semantic-ui-react'
import InformationBandeau from '../../generic/information-bandeau/information-bandeau'
import CompteBeneficiaires from '../../../model/entities/compte-beneficiaires'
import InformationCompteBeneficiairesLine from '../information-compte-beneficiaires-line/information-compte-beneficiaires-line'
import { SimpleButton } from '../../generic/simple-button'
import CreateCompteBeneficiairesForm from '../../investment/create-compte-beneficiaires-form'
import { FormErrorHeader } from '../../generic/form-error-header'

type Props = {
    accounts: CompteBeneficiaires [];
    onCancelAction: ()=> void;
    onValidateAction: (account: CompteBeneficiaires) => void;
}
export default function SelectCompteBeneficiairesForm({accounts, onCancelAction, onValidateAction}: Props) {
    const [selectedAccount, setSelectedAccount] = useState<CompteBeneficiaires | undefined>(undefined)
    const[isEdited, setIsEdited] = useState(false)
    const [isFormError, setIsFormError] = useState(false) 

    const validateStep = () => {
        if(!selectedAccount || selectedAccount === undefined){
            setIsFormError(true)
        }
        else{
            setIsFormError(false)
            onValidateAction(selectedAccount)
        }
    }

    return (
    <Form>
        <InformationBandeau 
        type="information"
        icon={{name:'info circle', size:"big", color:"blue"}}
        message="Pour pouvoir procéder au retrait de vos fonds, il vous faut sélectionner un compte vérifié parmi la liste suivante. Si elle est vide ou si vous souhaitez en ajouter un nouveau, vous pouvez le faire en cliquant sur le bouton “Ajouter un compte”. Une fois la vérification de celui-ci validée, il apparaîtra dans la liste."
        />
        <div>
            <FormErrorHeader 
                message="Veuillez sélectionner un compte"
                displayed={isFormError}
            />    
            {accounts && accounts.length > 0 && 
            accounts.map(account => 
                <InformationCompteBeneficiairesLine 
                    key={account.Id} 
                    account={account}
                    onSelected={(account) => setSelectedAccount(account)}
                    selectedAccount={selectedAccount}
                />
            )}
        </div>
        <div className='add-account-container'>
            <SimpleButton
                onClick={() => {
                setIsEdited(true);
                }}
                label='Ajouter un compte'
            />
            <Modal  onClose={() => setIsEdited(false)} open={isEdited}>
                <Modal.Header>Ajouter un compte bancaire</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                    <CreateCompteBeneficiairesForm
                        onSkipAction={() => setIsEdited(false)}
                    />
                    </Modal.Description>
                </Modal.Content>
            </Modal>  
        </div>
        <div className='button-bar'>
            <SimpleButton 
            label='Valider'
            onClick={validateStep}
            />
            <SimpleButton 
            label='Annuler'
            onClick={onCancelAction}
            />
        </div>
    </Form>
    )
}
